"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMainBranch = isMainBranch;
exports.isBranchSwitchingEnabled = isBranchSwitchingEnabled;
exports.isCustomizationBranch = isCustomizationBranch;
/**
 * Is the supplied branch name the main branch?
 * @param tenant
 * @param branchName
 */
function isMainBranch(tenant, branchName) {
    var _a;
    const mainBranchName = (_a = tenant.publicConfig) === null || _a === void 0 ? void 0 : _a.mainBranchName;
    if (branchName && mainBranchName) {
        return branchName === mainBranchName;
    }
    return true;
}
/**
 * Test if branch switching is enabled.
 * @param tenant
 */
function isBranchSwitchingEnabled(tenant) {
    var _a;
    return !!((_a = tenant.publicConfig) === null || _a === void 0 ? void 0 : _a.mainBranchName) && tenant.publicConfig.mainBranchName !== 'main';
}
/**
 * Returns a non-main branch name, if branch switching is enabled, otherwise null.
 * @param tenant
 * @param branchName
 */
function isCustomizationBranch(tenant, branchName) {
    if (!isBranchSwitchingEnabled(tenant)) {
        return null;
    }
    return branchName && !isMainBranch(tenant, branchName);
}
//# sourceMappingURL=SwitchBranchHelper.js.map